export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-crown-61de4cff86fa55d798702eff28d622b2.svg";